import { ZardSelectItemComponent } from '@/styles/components/select/select-item.component'
import { ZardSelectComponent } from '@/styles/components/select/select.component'

export const ZardSelectImports = [ZardSelectComponent, ZardSelectItemComponent] as const
